import { IS_MAIN_SCREEN, CLEAR_REDUX } from '../actionTypes';

const initialState = {
    isMainScreen: false,
}

export const mainScreenReducer = (state = initialState, action) => {
    switch (action.type) {
        case IS_MAIN_SCREEN:
            return {
                ...state,
                isMainScreen: action.payload
            };
        case CLEAR_REDUX:
            return initialState;
        default:
            return state;
    }
}